/**
 * Centralized API endpoint definitions. When the FastAPI contract changes,
 * this file + the service layer are the only places that should change.
 */
export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  DASHBOARD: {
    SUMMARY: '/dashboard/summary',
    CHARTS: '/dashboard/charts',
    ACTIVITIES: '/dashboard/activities',
    PENDING_ACTIONS: '/dashboard/pending-actions',
  },
  SETTINGS: {
    SYSTEM_CONFIG: '/settings/system-configuration',
  },
  WHATSAPP: {
    STATUS: '/whatsapp/status',
    CONNECT: '/whatsapp/connect',
    RESYNC: '/whatsapp/resync',
    DISCONNECT: '/whatsapp/disconnect',
  },
  ROLES: {
    LIST: '/roles',
    CREATE: '/roles',
    DETAIL: (id) => `/roles/${id}`,
    UPDATE: (id) => `/roles/${id}`,
    DELETE: (id) => `/roles/${id}`,
  },
  USERS: {
    LIST: '/users',
    CREATE: '/users',
    DETAIL: (id) => `/users/${id}`,
    UPDATE: (id) => `/users/${id}`,
    DELETE: (id) => `/users/${id}`,
  },
  NEWSPAPERS: {
    LIST: '/newspapers',
    OPTIONS: '/newspapers/options',
    DAILY_SUMMARY: '/newspapers/daily-summary',
    CREATE: '/newspapers',
    DETAIL: (id) => `/newspapers/${id}`,
    UPDATE: (id) => `/newspapers/${id}`,
    DELETE: (id) => `/newspapers/${id}`,
    DISMISS: (id) => `/newspapers/${id}/dismiss`,
  },
  CRON_JOBS: {
    LIST: '/cron-jobs',
    CREATE: '/cron-jobs',
    DETAIL: (id) => `/cron-jobs/${id}`,
    UPDATE: (id) => `/cron-jobs/${id}`,
    DELETE: (id) => `/cron-jobs/${id}`,
    TOGGLE: (id) => `/cron-jobs/${id}/toggle`,
  },
  ACTIVITY_LOGS: {
    LIST: '/activity-logs',
  },
  STAGE1: {
    LIST: '/stage1',
    DETAIL: (id) => `/stage1/${id}`,
    APPROVE: (id) => `/stage1/${id}/approve`,
    REJECT: (id) => `/stage1/${id}/reject`,
    BULK_APPROVE: '/stage1/bulk-approve',
    BULK_REJECT: '/stage1/bulk-reject',
    MANUAL_UPLOAD: '/stage1/manual-articles',
    MANUAL_TELEGRAM: '/stage1/manual-telegram-run',
  },
  STAGE2: {
    LIST: '/stage2',
    DETAIL: (id) => `/stage2/${id}`,
    ROUTE: (id) => `/stage2/${id}/route`,
  },
  BRIEFING: {
    LIST: '/briefing',
    DETAIL: (id) => `/briefing/${id}`,
    DECISION: (id) => `/briefing/${id}/decision`,
    DISPATCH: (id) => `/briefing/${id}/dispatch`,
    WHATSAPP_HISTORY: '/briefing/whatsapp-history',
    WHATSAPP_BATCH: (batchId) => `/briefing/whatsapp-history/${batchId}`,
    SCHEDULE: {
      GET: '/briefing/schedule',
      PUT: '/briefing/schedule',
    },
  },
  STORAGE1: {
    LIST: '/storage1',
    GET: '/storage1/:id',
    BUNDLES: '/storage1/bundles',
    DISPATCH: '/storage1/dispatch',
  },
  STORAGE2: {
    LIST: '/storage2',
    GET: '/storage2/:id',
  },
  OCR_STORAGE: {
    LIST: '/ocr-storage',
    GET: '/ocr-storage/:id',
    MANUAL_UPLOAD_OCR: '/ocr-storage/manual-upload-ocr',
    CHECK_EXISTS: '/ocr-storage/check-exists',
  },
  NO_STORAGE: {
    LIST: '/no-storage',
    DETAIL: (id) => `/no-storage/${id}`,
  },
  SEARCH: {
    STAGE1:       '/search/stage-one',
    STAGE2:       '/search/stage-two',
    BRIEFING:     '/search/briefing',
    STORAGE1:     '/search/storage-one',
    STORAGE2:     '/search/storage-two',
    NO_STORAGE:   '/search/no-storage',
    OCR_STORAGE:  '/search/ocr-storage',
  },
  NOTIFICATIONS: {
    LIST: '/notifications',
    UNREAD_COUNT: '/notifications/unread-count',
    MARK_ALL_READ: '/notifications/mark-all-read',
    MARK_READ: (id) => `/notifications/${id}/read`,
  },
};

export default API_ENDPOINTS;
